import * as React from 'react';
import { Heading2 } from "../../../../elements";
import { FormattedMessage } from '../ReadReportGuideModal';
export const AccessToReport = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading2, null,
            React.createElement(FormattedMessage, { id: 'readreport.guidemodal.access_to_report.title' })),
        React.createElement("section", { className: "ImageWithParagraph" },
            React.createElement("div", { className: "AccessToReportIcon" }),
            React.createElement("article", null,
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.access_to_report.paragraph1' })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.access_to_report.paragraph2' })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.access_to_report.paragraph3' }))))));
};
